import { Platform } from 'react-native';

/**
 * List of US timezone identifiers
 * These cover all US states and territories
 */
const US_TIMEZONES = [
  // Continental US
  'America/New_York',
  'America/Detroit',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Indiana/Indianapolis',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Vevay',
  'America/Chicago',
  'America/Indiana/Tell_City',
  'America/Indiana/Knox',
  'America/Menominee',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/North_Dakota/Beulah',
  'America/Denver',
  'America/Boise',
  'America/Phoenix',
  'America/Los_Angeles',
  // Alaska
  'America/Anchorage',
  'America/Juneau',
  'America/Sitka',
  'America/Metlakatla',
  'America/Yakutat',
  'America/Nome',
  'America/Adak',
  // Hawaii
  'Pacific/Honolulu',
  // US Territories
  'America/Puerto_Rico',
  'America/Virgin',
  'Pacific/Guam',
  'Pacific/Samoa',
];

/**
 * Detect if the user is likely outside the United States
 * Uses timezone as primary signal and locale as secondary
 * 
 * @returns {boolean} true if user appears to be international
 */
export function isLikelyInternational() {
  // Only run detection on web platform
  if (Platform.OS !== 'web') {
    return false;
  }

  try {
    // Primary check: timezone
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const isUSTimezone = US_TIMEZONES.includes(userTimezone);

    // Secondary check: browser locale
    const browserLanguage = typeof navigator !== 'undefined' ? navigator.language : '';
    const isUSLocale = browserLanguage === 'en-US';

    // User is likely international if:
    // - Not in a US timezone AND not using en-US locale
    // - OR not in a US timezone (even with en-US locale, they might be expats but still international for payment)
    return !isUSTimezone;
  } catch (error) {
    // If detection fails, assume US (don't show warning)
    console.warn('Country detection failed:', error);
    return false;
  }
}

/**
 * Get the user's detected timezone
 * Useful for debugging
 * 
 * @returns {string|null} The detected timezone or null
 */
export function getUserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return null;
  }
}
